/**
 * @file Created on Wed Aug 08 2018
 * @author PKl
 */
import StyledLabel from './styled/LabelStyled';
export default StyledLabel;